<script>
import { DeleteOutlined, EditOutlined } from '@ant-design/icons-vue';
import bem from '@/utils/bem';

const b = bem('social-ads');

export default {
  components: {
    DeleteOutlined,
    EditOutlined,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
    onEdit: {
      type: Function,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div :class="b('item')">
    <div :class="b('buttons')">
      <a-button
          class="action-button"
          type="primary"
          html-type="button"
          @click="() => onEdit(card)"
          ghost
      >
        <EditOutlined /> Edit
      </a-button>
      <a-popconfirm title="Sure to delete?" @confirm="() => onDelete(card.id)">
        <a-button
            type="primary"
            html-type="button"
            danger
            class="action-button"
            ghost
        >
          <DeleteOutlined /> Delete
        </a-button>
      </a-popconfirm>
    </div>
    <div  :class="b('content')">
      <div :class="b('title')">{{ card.title }}</div>
      <div :class="b('list')" v-if="card.socialsNetwork.length">
        <div
          :class="b('social-media')"
          v-for="item in card.socialsNetwork"
          :key="item.id"
        >
          <div :class="b('image-wrap')">
            <img
              :class="b('image')"
              :src="item.imageUrl"
              alt="article-preview"
            />
          </div>
          <span :class="b('social-media-description')">
            {{ item.title }}
          </span>
          <span :class="b('social-media-description')">
            {{ item.type }}
          </span>
          <span :class="b('social-media-description')">
            {{ item.link }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./socialAdsCartStyle.scss" lang="scss" scoped/>
